/**
 * Site menus — a website's NAMED navigation menus (header, footer, …).
 *
 * The menus themselves live on the website node's functional_specs and are
 * edited in the website settings form; these calls are the two edits that
 * reach beyond it. Authoring only (platform host). See backend
 * `routers/site_menus.py`.
 */

import api from './client'

export interface PageMenusInfo {
  site_id: string | null
  site_title?: string
  /** Names of the menus the page's website defines. */
  menus: string[]
  /** The menus this page appears in. */
  membership: string[]
  /** The site still decides menus by folder position (needs converting). */
  legacy: boolean
}

export interface ConvertSummary {
  menus: Record<string, number>
  moved_pages: string[]
  pages_rewritten: string[]
  removed_folders: string[]
  home: string | null
}

const base = (project: string) => `/site-menus/project/${encodeURIComponent(project)}`

export async function getPageMenus(project: string, page: string): Promise<PageMenusInfo> {
  const { data } = await api.get(`${base(project)}/page/${encodeURIComponent(page)}`)
  return data
}

export async function setPageMenus(project: string, page: string, menus: string[]): Promise<string[]> {
  const { data } = await api.put(`${base(project)}/page/${encodeURIComponent(page)}`, { menus })
  return data.membership as string[]
}

export async function getSiteMenuStatus(project: string, siteId: string): Promise<{ legacy: boolean; menus: string[] }> {
  const { data } = await api.get(`${base(project)}/sites/${encodeURIComponent(siteId)}/status`)
  return data
}

export async function convertSiteMenus(project: string, siteId: string): Promise<ConvertSummary> {
  const { data } = await api.post(`${base(project)}/sites/${encodeURIComponent(siteId)}/convert`)
  return data
}
